<template>
  <div class="organisation-form-field">
    <organisation-label v-if="value" :value="value" emptyText="Not selected"></organisation-label>
    <input :name="name" :value="value && value.id" type="hidden" />
    <button v-if="!hideChangeButton" type="button" @click="openPicker" class="btn btn-link">Change...</button>
    <Modal class="text-left" v-model="shown" title="Pick a new Organisation">
      <div style="width: 100%">
        <!-- <p class="text-big">
                Pick a new organisation
            </p> -->
        <div class="row">
          <div class="col-sm-12">
            <organisation-picker
              v-if="shown"
              :organisations="visibleOrganisations"
              :selection="selectedOrganisation"
              @selection-changed="onSelectionChanged"
            >
            </organisation-picker>
          </div>
        </div>
        <div class="row" v-if="errors && errors.length">
          <br />
          <div class="col-sm-12">
            <p class="col-sm-12 text-danger text-left" v-for="error in errors" v-bind:key="error">
              {{ error }}
            </p>
          </div>
        </div>
      </div>

      <template #footer>
        <div>
          <button
            type="button"
            class="btn btn-primary btn-lg"
            @click="updateSelection()"
            :disabled="!selectedOrganisation"
          >
            Change
          </button>

          <button type="button" class="btn btn-default btn-lg" @click="cancel()">Cancel</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import { Modal } from "uiv";
import { OrganisationDescriptionApiModel } from "../../../api-models";
import OrganisationPicker from "./organisation-picker.vue";
import OrganisationLabel from "./organisation-label.vue";

const props = defineProps<{
  name: string;
  initialValue: string | null;
  hideChangeButton?: boolean;
}>();

const value = ref<OrganisationDescriptionApiModel | null>(null);

const visibleOrganisations = ref<OrganisationDescriptionApiModel[]>([]);

const selectedOrganisation = ref<OrganisationDescriptionApiModel | null>(null);

const errors = ref<string[]>([]);

const shown = ref(false);

function close(): void {
  shown.value = false;
}

function cancel(): void {
  close();
}

onMounted(async () => {
  try {
    visibleOrganisations.value = (await axios.get("/api/organisation")).data;
    if (props.initialValue) {
      value.value = visibleOrganisations.value.find((o) => o.id === props.initialValue) || null;
    }
  } catch (e) {
    errors.value = ["Failed to load organisations"];
  }
});

function openPicker(): void {
  selectedOrganisation.value = null;
  errors.value = [];
  shown.value = true;
}

function onSelectionChanged(newSelection: OrganisationDescriptionApiModel): void {
  selectedOrganisation.value = newSelection;
}

function updateSelection(): void {
  if (!selectedOrganisation.value) {
    return;
  }
  value.value = selectedOrganisation.value;
  close();
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped></style>
